import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.158 1.333A.667.667 0 0 0 5.49 2v1.418a2.67 2.67 0 0 0-2 2.582v4a2.67 2.67 0 0 0 2 2.582V14c0 .368.298.667.667.667h4a.667.667 0 0 0 .666-.667v-1.418a2.666 2.666 0 0 0 2-2.582V6a2.67 2.67 0 0 0-2-2.582V2a.667.667 0 0 0-.666-.667zm3.333 2v-.666H6.824v.666zM6.158 4.667A1.333 1.333 0 0 0 4.824 6v4a1.334 1.334 0 0 0 1.334 1.333h4A1.333 1.333 0 0 0 11.49 10V6a1.333 1.333 0 0 0-1.333-1.333zm3.333 8.666v-.666H6.824v.666z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })